import { Directive, ViewContainerRef } from '@angular/core';
import { ViewContainerRefDir } from '../core/view-container-ref.directive';

@Directive({
  selector: '[libDialog]'
})
export class DialogDirective extends ViewContainerRefDir {
}
